import { render } from "./MonthPager.vue?vue&type=template&id=bdfd929a&scoped=true&ts=true"
import script from "./MonthPager.vue?vue&type=script&lang=ts"
export * from "./MonthPager.vue?vue&type=script&lang=ts"

import "./MonthPager.vue?vue&type=style&index=0&id=bdfd929a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdfd929a"]])

export default __exports__